import React, { useState, useEffect } from 'react';
import { AiOutlineClose } from 'react-icons/ai';
import { parseHtmlAttribution } from '../common/parseHtmlAttribution';
import '../../styles/components/map_interaction/PlaceInfoGallery.css';

const PlaceInfoGallery = ({ images, initialIndex, onClose }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(initialIndex);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'ArrowRight') {
        nextImage();
      } else if (event.key === 'ArrowLeft') {
        prevImage();
      } else if (event.key === 'Escape') {
        onClose();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [currentImageIndex, onClose]);

  const nextImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const handleThumbnailClick = (index) => {
    setCurrentImageIndex(index);
  };

  const getImageSrc = (image) => {
    return image.url || image.photo_reference;
  };

  return (
    <div className="modal place-gallery-modal" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <AiOutlineClose className="close-modal" onClick={onClose} />
        <div className="gallery-container">
          <div className="thumbnail-list">
            {images.map((image, index) => (
              <img
                key={index}
                src={getImageSrc(image)}
                alt={`Thumbnail ${index}`}
                className={`thumbnail ${index === currentImageIndex ? 'active' : ''}`}
                onClick={() => handleThumbnailClick(index)}
              />
            ))}
          </div>
          <div className="image-viewer">
            <button className="prev-button" onClick={prevImage} aria-label="Previous Image">
              &#10094;
            </button>
            <div className="image-container">
              <img
                src={getImageSrc(images[currentImageIndex])}
                alt="Place"
                className="modal-image"
              />
              {images[currentImageIndex].html_attributions &&
                images[currentImageIndex].html_attributions.length > 0 && (
                  <div className="gallery-photo-attribution">
                    {images[currentImageIndex].html_attributions.map((attribution, index) => (
                      <span key={index}>
                        {parseHtmlAttribution(attribution)}
                      </span>
                    ))}
                  </div>
                )}
            </div>
            <button className="next-button" onClick={nextImage} aria-label="Next Image">
              &#10095;
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlaceInfoGallery;
